import React, { ChangeEvent, FC } from "react";
import searchIcon from "../../assets/images/searchIcon.svg";
import style from "./style.module.scss";

interface ISearchInput {
  value: string;
  changeHandler: (str: string) => void;
  marginBottom?: string;
  placeholder?: string;
  ariaLabel?: string;
  width?: string;
  autoComplete?: string;
}

export const SearchInputV2: FC<ISearchInput> = ({
  value,
  changeHandler,
  marginBottom,
  ariaLabel,
  placeholder,
  width,
  autoComplete,
}) => {
  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    changeHandler(event.currentTarget.value);
  };
  return (
    <div
      className={style.wrapper}
      style={{
        marginBottom: marginBottom ? `${marginBottom}px` : "",
        width: width ? width : "",
      }}
    >
      <input
        onChange={onChange}
        value={value}
        className={style.input}
        placeholder={placeholder}
        aria-label={ariaLabel}
        autoComplete={autoComplete}
      />
      <img src={searchIcon} alt="searchIcon" className={style.icon} />
    </div>
  );
};
